export const isSaleProceedsField = ({ key, label, labelFr }) => {
  const value = `${key || ''} ${label || ''} ${labelFr || ''}`.toLowerCase();
  const compactValue = value.replace(/[^a-z]/g, '');

  return (
    value.includes('sale proceeds') ||
    value.includes('proceeds from sale') ||
    compactValue.includes('saleproceeds') ||
    compactValue.includes('proceedsfromsale')
  );
};
